import { useColorMode } from '@chakra-ui/react';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
  applyDocumentOverscrollBackground,
  resolveDocumentOverscrollBackground,
} from 'utils/documentOverscrollBackground';

const PUBLIC_LIGHT = '#FFFFFF';
const PUBLIC_DARK = '#0b1437';

/**
 * Sincroniza html/body/#root con el tipo de pantalla para evitar
 * franjas grisáceas al hacer overscroll en móvil o con trackpad.
 */
export default function DocumentOverscrollBackground(): null {
  const location = useLocation();
  const { colorMode } = useColorMode();

  useEffect(() => {
    const activeColorMode = colorMode === 'dark' ? 'dark' : 'light';
    const bg = resolveDocumentOverscrollBackground(location.pathname, {
      publicLight: PUBLIC_LIGHT,
      publicDark: PUBLIC_DARK,
      colorMode: activeColorMode,
    });
    document.documentElement.style.colorScheme = activeColorMode;
    applyDocumentOverscrollBackground(bg);
  }, [location.pathname, colorMode]);

  return null;
}
